import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Agent, AgentClient, UserProfile, UserRoleTypes} from "src/app/web-api-client";
import { ConfirmModalComponent } from "../../../modals/confirm-modal/confirm-modal.component";
import { SuccessModalComponent } from "../../../modals/success-modal/success-modal.component";
import { UnSuccessModalComponent } from "../../../modals/failed-modal/failed-modal.component";
import { AgentCreationComponent } from "./agent-creation/agent-creation.component";
import { AgentEditComponent } from "./agent-edit/agent-edit.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DateHelper } from "src/app/shared/helpers/date.helper";
import { WtStorageService } from "../../../wt-storage.service";


@Component({
  selector: 'app-agent',
  templateUrl: './agent.component.html',
  styleUrls: ['./agent.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class AgentComponent implements OnInit {

  public isLoaded: boolean = false;
  selectedObject: Agent;
  public allObjects: Agent[];
  public searchQuery: string = '';
  public filteredObjects: Agent[] = [];
  public currentUser: UserProfile;

  constructor(private readonly changeDetectionRef: ChangeDetectorRef, private readonly localStorage: WtStorageService, private readonly modalService: NgbModal,public client:AgentClient){

    this.currentUser = this.localStorage.getuser();
  }

  ngOnInit(): void {

    this.loadData();

  }


    private loadData() {
        this.client.getList().subscribe((allObjects: Agent[]) => {
            this.isLoaded = false;
          this.allObjects = allObjects;
          this.filteredObjects = allObjects;
            this.isLoaded = true;
            this.changeDetectionRef.detectChanges();
        });
  }

  public filterObjects() {
    if (this.searchQuery) {
      this.filteredObjects = this.allObjects.filter(object =>
        object.agentName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        object.agentEIK.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        object.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase()) 
        
      );
    } else {
      this.filteredObjects = this.allObjects;
    }
  }

 public onSelected(object:Agent){
   if (this.isSelected(object)){
    this.selectedObject = null;
  }
  else{

     this.selectedObject = object;
  }
 }

  public isSelected(object:Agent):boolean{
    return this.selectedObject == object;
 }

public onCreation():void{
  let modalRef = this.modalService.open(AgentCreationComponent, {});
  modalRef.componentInstance.onClose.subscribe(r => {
    this.loadData();
  });

}


public onDelete(): void {

    let modalRef = this.modalService.open(ConfirmModalComponent);

    modalRef.componentInstance.onClose.subscribe(result => {
      if (result === true) {

        this.client.remove(this.selectedObject.idAgent).subscribe(r => {
          this.modalService.open(SuccessModalComponent);
        })
      }
      else {
        this.modalService.open(UnSuccessModalComponent);
      }
    });


  }

  public onEdit(): void {

    let modalRef = this.modalService.open(AgentEditComponent, { size: 'lg' });
    modalRef.componentInstance.editObject = this.selectedObject;
    modalRef.componentInstance.onClose.subscribe(r => {
      this.loadData();
    });

    }
    public getDate(item:Date):string{
      return DateHelper.GetFormattedDate(item);
  }


  public canSee(): boolean {

    return this.currentUser.userRole != UserRoleTypes.User
  }
}
